// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.fermentation_changeset_state_enum */
var FermentationChangesetStateEnum;
(function (FermentationChangesetStateEnum) {
    FermentationChangesetStateEnum["armed"] = "armed";
    FermentationChangesetStateEnum["fired"] = "fired";
    FermentationChangesetStateEnum["removed"] = "removed";
    FermentationChangesetStateEnum["rejected"] = "rejected";
})(FermentationChangesetStateEnum || (FermentationChangesetStateEnum = {}));
;
export default FermentationChangesetStateEnum;
/** Zod schema for fermentation_changeset_state_enum */
export const fermentationChangesetStateEnum = z.nativeEnum(FermentationChangesetStateEnum);
//# sourceMappingURL=FermentationChangesetStateEnum.js.map